module.exports = __webpack_public_path__ + "static/img/c1.1bcc5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c1.png
// module id = 3uAW
// module chunks = 0